import { IGetFolhaPagamentoDropDownUseCase } from "../../../presentation/useCases/read/get_folha_pagamento_drop_down_use_case";
import { FolhaPagamentoDropDown } from "../../models/folha_pagamento_dropdown";
import { IRhRepository } from "../../repositories/rh_repository";

/**
 * GetFolhaPagamentoDropDownUseCase
 */

export class GetFolhaPagamentoDropDownUseCase implements IGetFolhaPagamentoDropDownUseCase {
  constructor(private readonly repository: IRhRepository) { }

  async getFolhaPagamentoDropDown(): Promise<FolhaPagamentoDropDown[]> {
    return await this.repository.getFolhaPagamentoDropDown();
  }
}
